<template>
    <div class="loading-screen" v-show="loading"  style="backgroundColor:rgba(255,255,255,0.8)">
        <component v-if="customLoader" v-bind:is="customLoader"></component>
        <div v-else style="text-align: -webkit-center">
            <div class="loading-circle"></div>
            <p class="loading-text">{{text}}</p>
        </div>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                text: "لطفا منتظر بمانید",
                dark: true,
                loading: false,
                background: null,
                customLoader: null
            }
        },
        computed: {
            bc () {
                return this.background || (this.dark ? 'rgba(0,0,0,0.8)' : 'rgba(255,255,255,0.8)')
            }
        },
    }
</script>
<style scoped>
    .loading-screen {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100vh;
        width: 100vw;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 300;
        flex-direction: column;
        user-select: none;
    }

    .loading-circle {
        width: 60px;
        height: 60px;
        border-radius: 100%;
        border: 4px solid transparent;
        border-left-color: #ababab;
        animation: circleanimation .45s linear infinite
    }

    .loading-text {
        margin-top: 15px;
        color: #ffffff;
        font-size: 18px;
        text-align: center;
    }

    @keyframes circleanimation {
        from {
            transform: rotateZ(0deg);
        }
        to {
            transform: rotateZ(360deg);
        }
    }
</style>
